// removed by extract-text-webpack-plugin
module.exports = {"badge":"badge--1S1il"};